import { render, staticRenderFns } from "./BottomMenu.vue?vue&type=template&id=90a1ef1c&scoped=true&"
import script from "./BottomMenu.vue?vue&type=script&lang=js&"
export * from "./BottomMenu.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sp/bottom_menu.css?vue&type=style&index=0&id=90a1ef1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a1ef1c",
  null
  
)

export default component.exports